interface ErrorDisplayProps {
  message: string;
  description?: string;
  onRetry?: () => void;
}

export default function ErrorDisplay({ message, description, onRetry }: ErrorDisplayProps) {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 text-center text-white"
      style={{
        backgroundImage: "url('/images/bg.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="max-w-sm rounded-3xl bg-black/70 px-6 py-8 shadow-lg backdrop-blur">
        <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-[#E63232]/15">
          <span className="text-3xl" role="img" aria-label="提示">
            ⚠️
          </span>
        </div>
        <h2 className="mb-2 text-xl font-semibold text-[#E63232]">{message}</h2>
        <p className="text-sm text-gray-200">
          {description || '请确认 NFC ID 是否正确，或稍后再试。'}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-white/90 px-6 py-2 text-sm font-semibold text-[#1B1B1B] transition hover:bg-white"
          >
            重新加载
          </button>
        )}
      </div>
    </div>
  );
}
